import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkMath from 'remark-math';
import remarkGfm from 'remark-gfm';
import rehypeKatex from 'rehype-katex';
import 'katex/dist/katex.min.css';
import './markdown-render.css';

interface MarkdownRenderProps {
  children: string;
  className?: string;
}

const MarkdownRender: React.FC<MarkdownRenderProps> = ({ children, className }) => {
  return (
    <div className={className}>
      <ReactMarkdown
        remarkPlugins={[remarkMath, remarkGfm]}
        rehypePlugins={[rehypeKatex]}
        components={{
          h1: ({ children }) => (
            <h1 className='!text-lg !font-bold !mb-0'>{children}</h1>
          ),
          h2: ({ children }) => (
            <h2 className='!text-base !font-bold !mb-0'>{children}</h2>
          ),
          h3: ({ children }) => (
            <h3 className='!text-sm !font-bold !mb-0'>{children}</h3>
          ),
          p: ({ children }) => <p className='!text-sm !mb-0'>{children}</p>,
          ul: ({ children }) => (
            <ul className='!text-sm list-disc list-inside !mb-2'>{children}</ul>
          ),
          ol: ({ children }) => (
            <ol className='!text-sm list-decimal list-inside !mb-2'>
              {children}
            </ol>
          ),
          li: ({ children }) => <li className='!text-sm'>{children}</li>,
          strong: ({ children }) => (
            <strong className='!font-bold !mb-0'>{children}</strong>
          ),
          em: ({ children }) => <em className='!italic'>{children}</em>,
          a: ({ href, children }) => (
            <a
              href={href}
              target='_blank'
              rel='noopener noreferrer'
              className='!text-sm !text-green-700 dark:!text-green-400 !underline !border-0 hover:!text-green-800 dark:hover:!text-green-300 !transition-colors'
            >
              {children}
            </a>
          ),
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownRender;
